import React, { useState, useEffect } from 'react'
import Loader from '../../../../presentationals/Loader/Loader.component'
import PiePage from '../CommonComponents/PiePage.component'
import InputField from '../CommonComponents/InputMUI'
import SelectField from '../CommonComponents/SelectMUI'
import { SaveUpdateFiDetailsData } from '../Community/AddEditDealer/DealerActioncreator'

const statusData = [
    {
        code: "Active",
        name: "Active",
    },
    {
        code: "Disabled",
        name: "Disabled",
    },
]



const agentTypeData = [
    {
        code: "Amu Agent Vendor",
        name: "Amu Agent Vendor"
    },
    {
        code: "Third Party Vendor",
        name: "Third Party Vendor"
    }
];




export default function BasicDetails({ Detaildata, handleTab}) {
    console.log("dssse",Detaildata)
    const [responseMsg, setresponseMsg] = useState("")
    const [errors, setErrors] = useState({})
    const [loaderState, setloaderState] = useState(false)
    const [parentVendorData, setParentVendorData] = useState([])
    const [Popup, setPopup] = useState({ show: false, status: '' })
    const [ObjectData, setObjectData] = useState({
        agentName: "",
        emailId: "",
        mobileNo: "",
        status: "",
        agentType: "",
    })


  

    useEffect(() => {
       
            if (Detaildata?.id || Detaildata?.fiAgentId) {
                setObjectData({
                    agentName: Detaildata?.agentName ??  "",
                    emailId: Detaildata?.emailId ??  "",
                    mobileNo: Detaildata?.mobileNo ??  "",
                    status: Detaildata?.status ??  "",
                    agentType: Detaildata?.agentType ??  "",
                })
            } else {
                setObjectData({
                    agentName: "",
                    emailId: "",
                    mobileNo: "",
                    status: "",
                    agentType: "",
                })
            }

      
    }, [Detaildata])


    const inputChange = (e, type) => {

        let changeObjectData = Object.assign({}, ObjectData)
        changeObjectData[type] = e

        setObjectData(changeObjectData)

    }


    const saveHandler = (e) => {
        if (e === 'save') {
            setloaderState(true)
            const obj = { ...ObjectData }
            if (Detaildata?.id) {
                obj.id = Detaildata?.id,
                obj.fiAgentId = Detaildata?.fiAgentId
            }
            SaveUpdateFiDetailsData(obj, (callback) => {
                setloaderState(false)
                if (callback.message == "success" && callback?.status == 200) {

                    setTimeout(() => {
                        handleTab("","list")
                    }, 200)

                } else if (callback?.status == 403 && callback?.message == "Email Id Or Mobile No Already Exist") {
                    setPopup({ show: true, status: "Email Id Or Mobile No Already Exist" })
                    removePopup()
                }
            })
        } else if (e === 'close') {
            handleTab("", "list")
        }
    }

    const closePopup = () => {
        setPopup({ show: false, status: "" })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }


    return (
        <>
            <div className='container hoverNone card'>
                {loaderState ?
                    <Loader />
                    : null}

                {
                    Popup.show ? <Popup popupStatus={Popup.status} /> : ''
                }

                <PiePage
                    totalPage={1}
                    currentPage={1}
                    heading={'Add FI Info'}
                />


                <div className='row'>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField
                            label="Agent Name"
                            variant="outlined"
                            value={ObjectData.agentName}
                            name="agentName"
                            id="agentName"
                            type="text"
                            onChange={e => inputChange(e, 'agentName')}
                            size="small"
                        // required={true}
                        />
                       

                    </div>
                    <div className='col-sm-4 col-xs-12  ' style={{ marginBottom: '12px' }} >
                        <InputField
                            label="Email Id"
                            variant="outlined"
                            value={ObjectData.emailId}
                            name="emailId"
                            id="emailId"
                            type="email"
                            onChange={e => inputChange(e, 'emailId')}
                            size="small"

                        />
                       


                    </div>
 <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <InputField

                            label="Mobile Number"
                            variant="outlined"
                            value={ObjectData.mobileNo}
                            name="mobileNo"
                            id="mobileNo"
                            type="number"
                            onChange={e => inputChange(e, 'mobileNo')}
                            size="small"

                        />
                        

                    </div>
                   
                </div>

                <div className="row">
                   
                  
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <SelectField
                            value={ObjectData.status}
                            label="Status"
                            onChange={e => inputChange(e, 'status')}
                            name="status"
                            data={statusData}
                            size={'small'}

                        />
                       

                    </div>
                    <div className='col-sm-4 col-xs-12 ' style={{ marginBottom: '12px' }}>
                        <SelectField
                            value={ObjectData.agentType}
                            label="Agent Type"
                            onChange={e => inputChange(e, 'agentType')}
                            name="agentType"
                            data={agentTypeData}
                            size={'small'}

                        />
                       

                    </div>
                </div>


                <div className='mb-3 mt-2 row' style={{ margin: '15px 0' }}>
                    <div className="form-text text-danger">{responseMsg}</div>
                    <div className="col-12 text-center">

                        <button className="cred-btn cancel-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('close')}>Close</button>

                        <button className="cred-btn" style={{ fontSize: '16px' }} onClick={e => saveHandler('save')}>Save</button>
                    </div>
                </div>
            </div>
        </>
    )
}
